var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Crea "+_vm._s(_vm.model.verboseName.toLowerCase()))]),_c('v-card-text',[_vm._t("form",null,null,{ error: _vm.error, submit: _vm.submit })],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }